import { useSelector } from "react-redux";
import NoAccessPage from "@entrilia/shared/components/NoAccessPage";
import AccessCheckPage from "../../auth/AccessCheckPage";
import { permissionsSelector, userEmailSelector } from "../../store/state/user/selectors";
import ClientSelectionList from "./ClientSelectionList";

const ClientSelectionPage = () => {
  const userEmail = useSelector(userEmailSelector);
  const permissions = useSelector(permissionsSelector);

  if (permissions.length === 0) {
    return <AccessCheckPage />;
  }

  return (
    <NoAccessPage userEmail={userEmail}>
      <ClientSelectionList permissions={permissions} />
    </NoAccessPage>
  );
};

export default ClientSelectionPage;
